import { useLocale } from 'locale';
import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import WarningIcon from 'assets/svg/warning-i.svg';
import { Terms, Title, Wrapper } from './styled';
import { Button } from 'ds/components/button';
import { loginWithPasswordAndConsents } from 'store/state/app/actions';
import { acceptConsentsResponseSelector } from 'store/state/mutationsResponse/selectors';
import { ConsentTypeNG, IConsent } from 'store/sagas/apiService/types';

const rules = 'השימוש במדלן למשקיעים כפוף לתנאי השימוש באתר מדלן. המידע במדלן למשקיעים הוא לא שומת מקרקעין, ולא מהווה תחליף לבדיקה תכנונית, שמאית, משפטית או אחרת. המידע גם לא כולל התייחסות לנתונים הספציפיים של כל נכס ונכס, ואין בו משום המלצה או מתן חוות דעת ביחס לביצוע עסקה. לפני ביצוע כל עסקה יש לערוך בדיקה ספציפית: מדלן לא תהיה אחראית לכל נזק שייגרם בגלל שימוש במדלן למשקיעים לצורך ביצוע עסקה, או בטענה של פגיעה בערך נכס. חשוב לזכור גם שהמידע במדלן למשקיעים צופה פני עתיד, והוא כולל הערכות ותחזיות - שעלולות שלא להתממש.';

const InvestorsLoginTermsBase: React.FC<{ onPasswordLoginWithConsents: (data: IConsent[]) => void; }> = ({ onPasswordLoginWithConsents }) => {
  const { t } = useLocale();
  // the accept round trip (AcceptConsents -> CurrentUser refetch -> navigation) gives no other
  // feedback; disable after the first click so it can't fire the mutation twice
  const [ isSubmitting, setIsSubmitting ] = useState(false);
  const acceptConsentsResponse = useSelector(acceptConsentsResponseSelector);

  // a failed accept (userWatcher shows an error toast and keeps the modal open) must re-enable
  // the button, or a non-dismissable modal becomes a dead end. The MUTATE reducer writes an
  // in-flight `{loading: true}` entry (spreading any previous response) the moment the mutation
  // dispatches, so only a terminal (!loading) non-success response counts as a failure; the
  // `{}` written by userWatcher's timeout resetMutationResponse also matches.
  useEffect(() => {
    const failed = acceptConsentsResponse && !acceptConsentsResponse.loading
      && !(acceptConsentsResponse.data && acceptConsentsResponse.data.acceptConsents && acceptConsentsResponse.data.acceptConsents.success);
    if (failed) setIsSubmitting(false);
  }, [ acceptConsentsResponse ]);

  const handleSubmit = () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    onPasswordLoginWithConsents([
      { type: ConsentTypeNG.INVESTORS_TERMS_AND_CONDITIONS, approval: true },
    ]);
  };

  return (
    <Wrapper>
      <WarningIcon width={40} height={40} />
      <Title>{t('investors.login.terms.title')}</Title>
      <Terms>{rules}</Terms>
      <Button fullWidth size="extraLarge" data-auto="investors-terms-accept" disabled={isSubmitting} onClick={handleSubmit}>{t('investors.login.terms.button')}</Button>
    </Wrapper>
  );
};

const mapDispatchToProps = {
  onPasswordLoginWithConsents: (data: IConsent[]) => loginWithPasswordAndConsents(data),
};

export const InvestorsLoginTerms = connect(null, mapDispatchToProps)(InvestorsLoginTermsBase);
